"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _jsx2 = _interopRequireDefault(require("@babel/runtime/helpers/jsx"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _compose = _interopRequireDefault(require("recompose/compose"));

var _pure = _interopRequireDefault(require("recompose/pure"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ErrorRedirect = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(ErrorRedirect, _React$Component);

  var _super = _createSuper(ErrorRedirect);

  function ErrorRedirect(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ErrorRedirect);
    _this = _super.call(this, props);
    _this.state = {
      remainingSeconds: 10
    };
    _this.tick = _this.tick.bind((0, _assertThisInitialized2.default)(_this));
    _this.doRedirect = _this.doRedirect.bind((0, _assertThisInitialized2.default)(_this));
    _this.redirectIfReady = _this.redirectIfReady.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(ErrorRedirect, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.setInterval(this.tick, 1000);
    }
  }, {
    key: "doRedirect",
    value: function doRedirect() {
      window.location = this.props.redirectTo || '/';
    }
  }, {
    key: "redirectIfReady",
    value: function redirectIfReady() {
      if (this.state.remainingSeconds <= 0 && !window.stay) {
        this.doRedirect();
      }
    }
  }, {
    key: "tick",
    value: function tick() {
      var remainingSeconds = this.state.remainingSeconds;

      if (remainingSeconds > 0) {
        var newTime = this.state.remainingSeconds - 1;
        this.setState({
          remainingSeconds: newTime
        }, this.redirectIfReady);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var style = this.props.style;
      return /*#__PURE__*/(0, _jsx2.default)("div", {
        style: style
      }, void 0, "We apologize for the inconvenience and will redirect you to the homepage in", ' ', /*#__PURE__*/(0, _jsx2.default)("time", {
        dateTime: 'PT' + this.state.remainingSeconds + 'S'
      }, void 0, this.state.remainingSeconds, " seconds"), ".");
    }
  }]);
  return ErrorRedirect;
}(_react.default.Component);

var _default = (0, _compose.default)(_pure.default)(ErrorRedirect);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/browser/error/ErrorRedirect.js
// module id = 1305
// module chunks = 25